import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, combineLatest } from 'rxjs';
import { CompanyUserService } from '../../company-user.service';
import { map, combineAll } from 'rxjs/operators';


@Component({
  selector: 'update-sites-popup',
  templateUrl: './update-sites-popup.html',
  styleUrls: ['./update-sites-popup.css',
    '../../../../admin-dashboard/common-popup/common-popup.css']
})
export class UpdateSitesPopup {
  roles = ['admin', 'editor', 'subscriber'];
  selectedOptions = [];

  objectKeys = Object.keys;
  companies = new Observable();
  companies$ = new Observable();
  
  constructor(public dialogRef: MatDialogRef<UpdateSitesPopup>,
    @Inject(MAT_DIALOG_DATA) public data,
    private companyUserService: CompanyUserService) {
    this.selectedOptions = data['sites'] ? data['sites'] : []
      
    this.companies =combineLatest(data.companies.map(({companyId,name}) =>{

           return this.companyUserService.getSitesByCompanyId$(companyId)
           .pipe(map(sitesList => {
            return {
              companyId: name,
              sites: sitesList.map(site => {
                return {
                  siteId: site.siteId,
                  name: site.name,
                  active: this.selectedOptions.filter(i => i == site.siteId).length > 0
                }
              }).sort((a, b) => {
                return a.name.localeCompare(b.name)
              })
            }
          }))  
    }))
  }

  onNgModelChange(site) {
    site.active = !site.active;

    if(site.active)
        this.selectedOptions.push(site.siteId)
    else
        this.selectedOptions =this. selectedOptions.filter(e => e !== site.siteId);
  
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
